import { FUTURES_PERIOD_OPTIONS } from '../constants/futuresPeriod';

const PERIOD_ENUM_TO_SECONDS = FUTURES_PERIOD_OPTIONS.reduce((map, option) => {
  map[option.enumName] = option.seconds;
  return map;
}, {});

/** 將後端 enum（_60s）或展示標籤（60s）轉為秒數 */
export function resolveFuturesPeriodSeconds(product) {
  if (!product) {
    return 0;
  }
  if (product.futuresPeriodType && PERIOD_ENUM_TO_SECONDS[product.futuresPeriodType]) {
    return PERIOD_ENUM_TO_SECONDS[product.futuresPeriodType];
  }
  return parseFuturesPlayConfig(product.playConfig).periodSeconds;
}

export function parseFuturesPlayConfig(playConfig) {
  if (!playConfig) {
    return { periodSeconds: 0, sealSeconds: 0, periodType: '' };
  }
  try {
    const json = typeof playConfig === 'string' ? JSON.parse(playConfig) : playConfig;
    const periodSeconds = Number(json.periodSeconds) || 0;
    const matched = FUTURES_PERIOD_OPTIONS.find((item) => item.seconds === periodSeconds);
    return {
      periodSeconds,
      sealSeconds: Number(json.sealSeconds) || 0,
      periodType: matched?.label || (periodSeconds ? `${periodSeconds}s` : ''),
    };
  } catch {
    return { periodSeconds: 0, sealSeconds: 0, periodType: '' };
  }
}

export function pickPrimaryFuturesProduct(products) {
  if (!Array.isArray(products) || products.length === 0) {
    return null;
  }
  return [...products].sort((a, b) => (a.sort ?? 9999) - (b.sort ?? 9999))[0];
}

/** 依交易對選擇交割商品（同標的多週期取 sort 最小） */
export function pickFuturesProductBySymbol(products, marketSymbolCode) {
  if (!marketSymbolCode) {
    return pickPrimaryFuturesProduct(products);
  }
  const normalized = String(marketSymbolCode).trim().toUpperCase();
  const matched = products.filter(
    (item) => String(item.marketSymbolCode || '').trim().toUpperCase() === normalized
  );
  if (matched.length === 0) {
    return pickPrimaryFuturesProduct(products);
  }
  return [...matched].sort((a, b) => (a.sort ?? 9999) - (b.sort ?? 9999))[0];
}

/** 同行情標的下依週期秒數找商品（優先 futuresPeriodType） */
export function findFuturesProductByPeriod(products, marketSymbolCode, periodSeconds) {
  return products.find((item) => {
    if (item.marketSymbolCode !== marketSymbolCode) {
      return false;
    }
    return resolveFuturesPeriodSeconds(item) === periodSeconds;
  });
}

/** 該標的可用週期 tabs（有對應商品才顯示） */
export function listPeriodTabsForSymbol(products, marketSymbolCode) {
  return FUTURES_PERIOD_OPTIONS.filter((option) =>
    findFuturesProductByPeriod(products, marketSymbolCode, option.seconds)
  );
}

export function formatOddsPercent(value) {
  if (value == null || value === '') {
    return '—';
  }
  const num = Number(value);
  if (Number.isNaN(num)) {
    return '—';
  }
  if (num <= 2) {
    return `${(num * 100).toFixed(2)}%`;
  }
  return `${num.toFixed(2)}%`;
}

export function formatRoundOptionLabel(round) {
  if (!round) {
    return '';
  }
  const time = round.startTime ? round.startTime.slice(11, 16) : '—';
  return `${time} (${round.roundCode || round.issueNumber || ''})`;
}

export { formatPrice } from './timedPlayConfig';
